import { render } from "./FooterViewOld.vue?vue&type=template&id=90392b54&scoped=true"
import script from "./FooterViewOld.vue?vue&type=script&lang=js"
export * from "./FooterViewOld.vue?vue&type=script&lang=js"

import "./FooterViewOld.vue?vue&type=style&index=0&id=90392b54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90392b54"]])

export default __exports__